const OnBeforeUnloadPort = {
  add: function (app) {
    window.addEventListener("beforeunload", () => {
      app.ports.onBeforeUnload.send(true);
    });
  },
};

module.exports = OnBeforeUnloadPort;
